import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

export function Loading() {
  const { t } = useTranslation()
  return (
    <p role="status" className="px-8 py-24 text-center text-lg font-bold text-subtle">
      {t('common.loading')}
    </p>
  )
}

export function ErrorState({ notFound = false }) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center gap-5 px-8 py-24 text-center">
      <img src="/brand/urbanpurr-mark.svg" alt="" className="w-40" />
      <p className="text-lg font-bold text-muted">{notFound ? t('common.notFound') : t('common.error')}</p>
      <Link to="/" className="rounded-full bg-ink px-6 py-3 font-extrabold text-on-ink no-underline">
        {t('common.backHome')}
      </Link>
    </div>
  )
}

export default function NotFoundPage() {
  return <ErrorState notFound />
}
